<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :disabled="!!id"
                    :repository="repositories.procedimento"
                    :search-fields="fields.autocompletes.procedimento"
                    :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                    :validations="validations.procedimento"
                    label="Procedimento"
                    v-model="model.procedimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.apelido"
                    label="Apelido"
                    v-model="model.apelido"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, formats } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                autocompletes: {
                    procedimento: [
                        { key: 'nome', searchable: true },
                        { key: 'codigo', searchable: true }
                    ]
                }
            }
        },
        validations() {

            return {
                procedimento: { required: true },
                apelido: { required: true, max: 100 },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacaoProcedimento: this.getConectaSusRepository('parametrizacao.procedimento'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

        this.load()
    },
    data: () => ({
        model: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.parametrizacaoProcedimento.edit(this.id)
                : this.repositories.parametrizacaoProcedimento.create()

            request
                .then(({ data }) => this.model = data.model)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.parametrizacaoProcedimento.update(this.id, this.prepareData())
                        : this.repositories.parametrizacaoProcedimento.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            if (!this.id) {

                data.procedimentoCodigo = data.procedimento.codigo
            }

            delete data.procedimento

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, stringCase, object, error, formats],
    props: {
        id: { type: Number }
    },
}
</script>